module.exports = __webpack_public_path__ + "img/scan.1fe9aa29.svg";